import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { PaginationModel } from '../../../models/pagination.model'
import { SortingModel } from '../../../models/sorting.model'
import { HelperService } from '../../helper.service'
import { environment } from '../../../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class SqlAlertsService {
  private apiURL: string = environment.apiUrl + '/sql-alerts'

  constructor(private http: HttpClient) {}

  public getItems(
    pagination: PaginationModel,
    filter: any = null,
    sort: SortingModel = null,
  ): Observable<any> {
    const query: string = HelperService.complexObjectToQuery({
      filter: filter ? filter.toJson() : null,
      sort: sort,
      pagination: pagination,
    })
    const url = this.apiURL + '/items?' + query
    return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map((resource: any) => {
        return resource
      }),
    )
  }

  public getLogFiles(): Observable<string[]> {
    const url: string = environment.apiUrl + '/logs'
    return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map((resource: any) => {
        return resource
      }),
    )
  }

  public getLogFile(file: string): Observable<string[]> {
    const url: string = environment.apiUrl + '/logs/' + encodeURIComponent(file)
    return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map((resource: any) => {
        return resource
      }),
    )
  }

  public getSupportEmail(): Observable<string | null> {
    const url = environment.apiUrl + '/env/support-email'
    const headers = new HttpHeaders().set('Content-Type', 'application/json')
    return this.http.get(url, { headers: headers }).pipe(
      map((resource: any) => resource?.SUPPORT_EMAIL ?? null),
    )
  }

  private getHeaders(): HttpHeaders {
    return new HttpHeaders().set('Content-Type', 'application/json')
  }
}
